import { render } from "./VolumaTeurs.vue?vue&type=template&id=a530576e&scoped=true"
import script from "./VolumaTeurs.vue?vue&type=script&lang=js"
export * from "./VolumaTeurs.vue?vue&type=script&lang=js"

import "./VolumaTeurs.vue?vue&type=style&index=0&id=a530576e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a530576e"]])

export default __exports__